module.exports = __webpack_public_path__ + "static/socialData-e4e4bc2d034fa385ee6940d74e07855e.jpg";